<template>
  <div v-if="hasModule('PRSID:MATCH:OPTIONS:PERSONTAB:VIEW')">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Match Options
          </div>
        </template>
      </es-header>
    </div>
    <!-- <div class="tabs-container no-border-top">
      <div class="tabs">
        <ul>
          <router-link
            :to="{ name: 'pidMatchOptionsPerson' }"
            tag="li"
            replace
          >
            <a>PERSON</a>
          </router-link>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
import EsHeader from '@/components/EsHeader.vue';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    PermissionManager,
  ],
  components: {
    EsHeader,
  },
};
</script>

<style lang="sass" scoped>
</style>
